import { createFileRoute, redirect } from '@tanstack/react-router'
import { CompanyList } from '@/features/companies/company-list'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the companies screen — design 1k's "add entity ·
 * hierarchy · branches nest under entities".
 *
 * The grant gate is presentation only: the API enforces `company.view` on
 * every companies endpoint, so a stale grant still 403s server-side; this
 * only keeps a user without the grant out of a screen they cannot use.
 */
export const Route = createFileRoute('/_authenticated/companies')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'company.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: CompanyList,
})
